/**
 * Преобразования байтов. Никаких зависимостей: этот модуль подключается и в
 * Service Worker, которому нельзя тянуть за собой libsodium — воркер должен
 * просыпаться по пушу мгновенно, а не грузить WASM.
 */

export function toBase64(bytes: Uint8Array): string {
  let binary = '';
  // Пачками, иначе на длинном сообщении String.fromCharCode переполнит стек.
  const CHUNK = 0x8000;
  for (let i = 0; i < bytes.length; i += CHUNK) {
    binary += String.fromCharCode(...bytes.subarray(i, i + CHUNK));
  }
  return btoa(binary);
}

export function fromBase64(value: string): Uint8Array {
  const binary = atob(value);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return bytes;
}

/** base64url без выравнивания — в таком виде браузер отдаёт ключи push-подписки. */
export function fromBase64Url(value: string): Uint8Array {
  const padded = value.replace(/-/g, '+').replace(/_/g, '/');
  return fromBase64(padded + '='.repeat((4 - (padded.length % 4)) % 4));
}

export const encodeUtf8 = (text: string): Uint8Array => new TextEncoder().encode(text);
export const decodeUtf8 = (bytes: Uint8Array): string => new TextDecoder().decode(bytes);
